<template>
    <v-row>
      <v-col cols="8">
        <draggable
            class="list-group"
            tag="div"
            v-model="facets"
            v-bind="dragOptions"
            @start="drag = true"
            @end="drag = false"
            @change="onDrag"
        >
          <transition-group type="transition" :name="!drag ? 'flip-list' : null">
            <div
                class="list-group-item"
                v-for="facet in facets"
                :key="facet.id"
            >
              <v-row align="center" class="v-facet">
                <v-col cols="1">
                  <v-btn icon>
                    <i class="fa fa-arrows-v"></i>
                  </v-btn>
                </v-col>
                <v-col cols="10">
                  <v-row>
                    <v-col cols="6">
                      <v-checkbox
                          :label="facet.content"
                          v-model="facet.isEnabled"
                          @change="switchEnable(facet.id, $event)"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="5">
                      <v-switch
                          :value="true"
                          v-model="facet.isHierarchyDisabled"
                          @change="switchHierarchyDisabled(facet)"
                          :label="Translator('admin.notice_collection.facets.disable_order')"></v-switch>
                      <v-switch
                          :value="true"
                          v-model="facet.searchable"
                          @change="switchSearchDisabled(facet)"
                          :label="Translator('admin.notice_collection.facets.display_search')"></v-switch>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="1">
                  <v-btn dark color="primary" small fab @click="updateCurrentFacet(facet)">
                    <v-icon small dark>mdi-pencil</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </transition-group>
        </draggable>
      </v-col>
      <v-col cols="4" v-if="currentFacet && !isCurrentFacetLoading">
        <h3>{{ Translator('admin.notice_collection.facets.current', {'name': currentFacet.content}) }}</h3>
        <v-text-field
            v-if="!currentFacet.isHierarchyDisabled"
            v-model="currentFacet.subNodesRendered"
            @change="updateSubNodesRendered"
            type="number"
            :label="Translator('admin.notice_collection.facets.show_all')">
        </v-text-field>
        <v-treeview
            item-key="id"
            item-children="children"
            item-text=null
            :load-children="fetchFacets"
            :items="currentFacetChildren">
          <template v-slot:prepend="{ item }">
            <v-switch
                :value="true"
                :input-value="item.isEnabled"
                @change="switchEnable(item.id, $event !== null)"
                :label="item.content"
            ></v-switch>
          </template>
        </v-treeview>
      </v-col>
      <v-col cols="4" class="text-center" v-if="isCurrentFacetLoading">
        <v-progress-circular
            :size="70"
            :width="7"
            indeterminate
            color="primary"
        ></v-progress-circular>
      </v-col>
    </v-row>
</template>

<style lang="scss">
  .v-treeview {
    .v-input__control {
      .v-input__slot {
        margin-bottom: 0;
        label {
          margin-bottom: 0;
        }
      }
      .v-messages {
        display: none;
      }
    }
  }
  .v-input {
    &.v-input--selection-controls {
      margin-top: 0;
    }
  }
</style>
<script>

import draggable from 'vuedraggable'
import FacetAPI from '@/api/facet'
import PositionsAPI from '@/api/positions'
import axios from 'axios'

export default {
  name: 'AdminFacets',
  components: {
    draggable,
  },
  data () {
    return {
      facets: [],
      drag: false,
      isCurrentFacetLoading: false,
      currentFacet: null,
      currentFacetChildren: []
    }
  },
  mounted () {
    this.getFacets()
  },
  methods: {
    updateCurrentFacet(facet, next = null) {
      if(!next) {
        this.currentFacetChildren = [];
        this.isCurrentFacetLoading = true;
      }
      this.currentFacet = facet
      FacetAPI.tree(null, this.currentFacet.id, null, null, null, null, null, null, next)
        .then(response => {
          if( this.currentFacet !== facet ) return;
          response.data.data.forEach( item => {
            if( !item.hasChildren ) delete item.children;
            return item;
          })
          this.currentFacetChildren.push(...response.data.data);
          if( this.currentFacetChildren.length < response.data.facetCount ) {
            this.updateCurrentFacet(facet, this.currentFacetChildren[ this.currentFacetChildren.length - 1].id );
          }
          this.isCurrentFacetLoading = false;
        })
    },
    async fetchFacets (item, next = null) {
      if(!next) item.children = [];
      this.subCurrentFacet = item;
      return FacetAPI.tree(null, item.id, null, null, null, null, null, null, next)
        .then(response => {
          if( this.subCurrentFacet !== item ) return;
          response.data.data.forEach( el => {
            if( !el.hasChildren ) delete el.children;
            return el;
          })
          item.children.push(...response.data.data);
          if( item.children.length < response.data.facetCount ) {
            this.fetchFacets(item, item.children[ item.children.length - 1].id );
          }
        })
    },
    switchEnable (index, value) {
      FacetAPI.update(index, {
        isEnabled: value
      })
    },
    switchSearchDisabled(facet) {
      FacetAPI.update(facet.id, {
        searchable: !!facet.searchable
      })
    },
    switchHierarchyDisabled (facet) {
      FacetAPI.update(facet.id, {
        isHierarchyDisabled: facet.isHierarchyDisabled
      }).then( () => {
        this.updateCurrentFacet(this.currentFacet);
      })
    },
    updateSubNodesRendered (value) {
      FacetAPI.update(this.currentFacet.id, {
        subNodesRendered: parseInt(value)
      })
    },
    onDrag: function () {
      let positions = []
      this.facets.forEach((facet, index) => {
        positions.push({
          id: facet.id,
          position: index + 1
        })
      })
      PositionsAPI.updates('facets', positions)
    },
    getFacets () {
      axios
          .get('/api/v2/facets', {
            params: {
              'exists[parent]': false,
              'exists[facetAggregation]': false
            }
          })
          .then(response => {
            this.facets = response.data['hydra:member']
          })
    },

    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    }
  }
  ,
  computed: {
    dragOptions () {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost'
      }
    }
  }
}
</script>
